// import CryptoJS  from './crypto-js.js'
// import JSEncrypt  from './jsencrypt.js'
// import jsrsasign   from './jsrsasign.js'



//时间戳转年/月/日
function transfer_time_stamp(time_stamp) {
	console.log(Array.isArray(time_stamp))
	if (Array.isArray(time_stamp)) {
		for (let i = 0; i < time_stamp.length; i++) {
			let add_time = new Date(time_stamp[i].add_time * 1000);
			time_stamp[i].add_time = add_time.getFullYear() + '-' + ('00' + (add_time.getMonth() + 1)).slice(-2) + '-' +
				('00' + add_time.getDate()).slice(-2) + ' ' + ('00' + add_time.getHours()).slice(-2) + ':' + ('00' +
					add_time.getMinutes()).slice(-2)
		}
		return time_stamp
	} else {
		let add_time = new Date(time_stamp * 1000);
		add_time = add_time.getFullYear() + '-' + ('00' + (add_time.getMonth() + 1)).slice(-2) + '-' + ('00' + add_time
			.getDate()).slice(-2) + ' ' + ('00' + add_time.getHours()).slice(-2) + ':' + ('00' + add_time
			.getMinutes()).slice(-2)
		return add_time
	}
}
//二分查找
function binarySearch(arr, target) {
	let left = 0
	let right = arr.length - 1
	while (left <= right) {
		const mid = Math.floor((left + right) / 2)
		if (arr[mid] === target) {
			return mid
		} else if (arr[mid] < target) {
			left = mid + 1
		} else {
			right = mid - 1
		}
	}
	return -1
}
// 快排
function quickSort(arr) {
	if (arr.length <= 1) {
		return arr
	}
	let left = []
	let right = []
	let middle = arr.splice(0, 1)[0]
	for (let i = 0; i < arr.length; i++) {
		if (arr[i] < middle) {
			left.push(arr[i])
		} else {
			right.push(arr[i])
		}
	}
	//递归
	return quickSort(left).concat([middle], quickSort(right))
}
// 对象数组排序
function compare(prop) {
	return function(obj1, obj2) {
		var val1 = obj1[prop];
		var val2 = obj2[prop];
		if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
			val1 = Number(val1);
			val2 = Number(val2);
		}
		if (val1 < val2) {
			return -1;
		} else if (val1 > val2) {
			return 1;
		} else {
			return 0;
		}
	}
}
//base64转为blob
function convertBase64UrlToBlob(cropFilePath) {
	var bytes = window.atob(cropFilePath.split(',')[1]); //去掉url的头，并转换为byte
	//处理异常,将ascii码小于0的转换为大于0
	var ab = new ArrayBuffer(bytes.length);
	var ia = new Uint8Array(ab);
	for (var i = 0; i < bytes.length; i++) {
		ia[i] = bytes.charCodeAt(i);
	}
	return new Blob([ab], {
		type: 'image/png'
	});
};
// 格林民治时间换成现在的时间
function time_second(time, type) {
	var chinaStandard = time
	var date = new Date(chinaStandard);
	console.log(date, "1234")
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	var h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	var minute = date.getMinutes();
	var seconds = date.getSeconds()
	seconds = seconds < 10 ? ('0' + seconds) : seconds;
	minute = minute < 10 ? ('0' + minute) : minute;
	if (type == 1) {
		return time = y + '-' + m + '-' + d
	} else if (type == 2) {
		console.log(time, "1234")
		return time = h + ':' + minute + ':' + seconds
	} else {
		return time = y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + seconds
	}
}
// 获取年月日
function getNowFormatDate() {
	var date = new Date();
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
}
// 把时间转成格林威治时间
function StrToGMT(time) {
	let GMT = new Date(time)
	return GMT
}
//把时间分割成年-月-日
function times(data) {
	var time1 = data.substring(0, 4) + '-' + data.substring(4, 6) + '-' + data.substring(6, 8)
	return time1
}
// 封装会员管理的颜色
function vip_color(type) {
	if (type == 1 || type == 3) {
		return 'color:#ff0000'
	} else {
		return 'color:#333333'
	}
}
//封装服务选购的时间
function choose_time(date, monthNum) {
	var dateArr = date.split('-');
	var year = dateArr[0]; //获取当前日期的年份
	var month = dateArr[1]; //获取当前日期的月份
	var day = dateArr[2]; //获取当前日期的日
	var days = new Date(year, month, day);
	days = days.getDate(); //获取当前日期中的月的天数
	var year2 = year;
	var month2 = parseInt(month) + parseInt(monthNum);
	if (month2 > 12) {
		year2 = parseInt(year2) + parseInt((parseInt(month2) / 12 == 0 ? 1 : parseInt(month2) / 12));
		month2 = parseInt(month2) % 12;
	}
	var days2 = new Date(year2, month2, days);
	days2 = days2.getDate();
	if (month2 < 10) {
		month2 = '0' + month2;
	}
	if (days2 < 10) {
		days2 = '0' + days2;
	}
	var t2 = year2 + '-' + month2 + '-' + days2;
	return t2
}

// 时间戳计算未来莫一天剩余天数转时间格式
function timeStamp(times) {
	var timestamp = Date.parse(new Date());
	timestamp = timestamp / 1000;
	var letime = times - timestamp;
	if (letime <= 0) {
		time = false
		return time;
	}
	var time = parseInt(letime);
	if (parseInt(letime) > 60) {
		var second = parseInt(letime) % 60;
		var min = parseInt(letime / 60);
		time = min + "分" + second + "秒";
		if (min > 60) {
			min = parseInt(letime / 60) % 60;
			var hour = parseInt(parseInt(letime / 60) / 60);
			time = hour + "时" + min + "分" + second + "秒";
			if (hour >= 24) {
				hour = parseInt(parseInt(letime / 60) / 60) % 24;
				var day = parseInt(parseInt(parseInt(letime / 60) / 60) / 24);
				time = ('00' + day).slice(-2) + "天" + ('00' + hour).slice(-2) + "时" + ('00' + min).slice(-2) + "分" + (
					'00' + second).slice(-2) + "秒";
			}
		}
	}
	return time;
};

//aes加密
function encrypt(word, keyStr) {
	keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
	var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
	var srcs = CryptoJS.enc.Utf8.parse(word);
	var encrypted = CryptoJS.AES.encrypt(srcs, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString();
};
//aes解密
function decrypt(word, keyStr) {
	keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
	var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
	var decrypt = CryptoJS.AES.decrypt(word, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};

//  rsa加密  
function encryptedData(publicKey, data) {
	// 新建JSEncrypt对象  
	let encryptor = new JSEncrypt();
	// 设置公钥  
	encryptor.setPublicKey(publicKey);
	// 加密数据  
	return encryptor.encrypt(data);
};
// rsa解密  
function decryptData(privateKey, data) {
	// 新建JSEncrypt对象  
	let decrypt = new JSEncrypt();
	// 设置私钥  
	decrypt.setPrivateKey(privateKey);
	// 解密数据  
	return decrypt.decrypt(secretWord);
};
//数字签名加密
function jsrsasignData(data) {
	// 创建RSAKey对象
	let rsa = new jsrsasign.RSAKey();
	//因为后端提供的是pck#8的密钥对，所以这里使用 KEYUTIL.getKey来解析密钥
	let private_key =
		`-----BEGIN PRIVATE KEY-----MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQClaGRYxZUTrB1u+pbMG8eBQN2EUOv+I1yfza/ASXqVzQMdhEkp+VhN72k6BZT32RrtVEmGswuyjsbFMZadpcE+9orVxU7y2c3NMgHftcmV5utlPR6vkBmd1gL1tJJcZEIcTfIT/uwqlPiP341Uov4lhse14fornZMKWLkEIfEndrEty2vcOvERXLcoGadr8cgFG/piGPP7QmFmbZyhNJwGsGySEOb/J9+vu2NRXU9UL8gQ87RJx+LkTqtvbvge/Rfxcf7FFpM6yBpBhE5Jc+gphZBjXXpJeIJCu7oxBVWOuLVAzHCabOR8TvGskMuMnTLKbRY44RgZ8Vz5iqpaODG/AgMBAAECggEAa++5O6yDYXj5JAhmCv89qvy3ELb1qLtOoAFK5MGOOt6zX7mJPNi3ZPQLyI8H7MxBpAlSiZGg2n4M+3Umge0+M2YSpvjAUf0LLRGq417vEuDDTycZNRtle/fBqrCQqbXK5kl+5Ml/NzJLGSeaRFawXbCb9fZml7uVzjSjVy0G/uaKlNPtfj5yXOWPIB+G4FyC3K85UEJj+tjamE/sg89CnlDn2kCgmxKzNKK8FagIFy4p9PPw41npUYLXwg+NOgVfSw0REfrT32+hgDp3u7ZXX4AMjZ1kmQeE15+0ALLPkbn9cxRca0TJRriMHazqQUYkyeFQSqAYh1opH17rBdRrsQKBgQDQu7k6NSGh4NQZtXzHae2GYQQy90SqMLFW/P1icfQNMz1hmeVARx6tcWX9NY4GxwGOe1WAV0YIpOPQMpGf9vMt9oV9snvatZ+D6nTmNlEoGiCt/MUcmHq4QWxKDVib8J9N0z3/yw/F/+7D3jusYER/E4xDOft9ZSq3p+18U2BbYwKBgQDK3RY9FcgTJz5mUWXw4JUHLIbYK13k+oKLt0ENWb4bZ70vauiUCD3JxEcyE08NLKjlgm1hrE9Tfi+xy/vLMvpIUWiI4lt5EPjWOWS4W9ePDBTNcIhJQJ7KgEiOahoTrkCU7Xe+mFtIufktfk38ntuFZOFo6TmbF7KQ0DgPk78U9QKBgGYSZpHASaIPf6jSxyH8+tortxH1OO7AwPf43y+06dNKq0l/KEw2exn1yhn4hmtqBajXRwhrpSO0/nJhSDUhXemsE7tT/J0HE+o+TMwG48joffKXGQzSw7A2ze2oeRxInp5AHqFne18nuGqv0h6JNPWvaXe2cvTu8+S7ibayTvxhAoGAAre/ioX2LjuCXICOqxF3LadtDwxVr7Gjehe0aWdgYqGbKT13bDRID6Hvij4z+us0QA7lRD+4uFeib/FZqDlAnSNqERtnOlH943DVZprkYmg5Bx+Q09pnxjK9xhqpysW028nqpsUHxAupyPA+PzopmrnlQzCMswU4QTRo69yA3NkCgYAOZF4pK4Zypxj6y2gOiEEtgQnjEP8/00Tl61B+5b4/eH4VCs9S2O0nUAYBatkN5I1C5Y3nqeN/y02CApVmkscfO9kL0hNBwiPW7OyA1P0ALER+9i7bu6LRB+sg0WLjk6bF4lN1VCPkVK+NBvuzXO4vchFDTNa50SeyHp7+AXZwMA==-----END PRIVATE KEY-----`
	// 将密钥转码
	rsa = jsrsasign.KEYUTIL.getKey(private_key);
	// 创建Signature对象，设置签名编码算法
	let sig = new jsrsasign.KJUR.crypto.Signature({
		"alg": "SHA1withRSA"
	});
	// 初始化
	sig.init(rsa)
	// 传入待加密字符串
	sig.updateString(data)
	// 生成密文
	let sign = jsrsasign.hextob64(sig.sign());
	// 对加密后内容进行URI编码
	// sign = encodeURIComponent(sign);
	//把参数与密文拼接好，返回
	// let params = data+'&sign='+sign; 
	return sign
}











export default {
	transfer_time_stamp, //时间戳转年/月/日
	binarySearch, //二分查找
	quickSort, // 快速排序
	compare, // 数组对象排序
	convertBase64UrlToBlob, //base64转为blob
	timeStamp, // 时间戳转天数
	// encrypt,		//aes加密
	// decrypt,		//aes解密
	// encryptedData,		//rsa加密
	// decryptData,		//rsa加密
	// jsrsasignData,		//数字签名加密
	time_second, //element ui 时间转成现在的时间
	getNowFormatDate, //将现在的时间转成element ui 时间
	StrToGMT, //把时间转成格林威治时间
	times, //转成需要年-月-日
	vip_color, //会员的颜色 
	choose_time, //封装服务的时间
}